<template>
  <div class="seller" v-infinite-scroll="getData" infinite-scroll-disabled="busy" infinite-scroll-distance="150" infinite-scroll-root>
    <v-img :src="$HOST_URL + seller.wallpaper" 
        :height="$vuetify.breakpoint.xsOnly ? 200 : 300"></v-img>
    <v-container>
      <v-row no-gutters>
        <v-col class="left-info">
          <div class="py-2 px-4 text-center">
            <v-avatar :size="$vuetify.breakpoint.xsOnly ? 140 : 180" class="icon">
              <v-img :src="$HOST_URL + seller.usericon"/>
            </v-avatar>
            <div class="d-flex justify-center mt-8">
              <div class="other-info">
                <div>{{ seller.followers　}}</div>
                <div>粉絲</div>
              </div>
              <div class="other-info">
                <div>{{ seller.follows　}}</div>
                <div>追蹤中</div>
              </div>
            </div>
            <div class="py-8" v-if="Object.keys(seller).length">
              <v-btn block dark color="indigo" @click="goChatroom">
                <v-icon class="mr-4">fas fa-comments</v-icon>
                開始聊天
              </v-btn>
              <span @click="$store.dispatch('user/follow', seller.id, getSeller)">
                <v-btn v-if="!isFollow" dark block color="pink" class="d-block mx-auto mt-4">追蹤對方</v-btn>
                <v-btn v-else dark block outlined color="pink" class="d-block mx-auto mt-4">追蹤中</v-btn>
              </span>
              <span @click="$store.dispatch('user/block', seller.id, getSeller)">
                <v-btn v-if="!isBlock" dark block color="red darken-2" class="d-block mx-auto mt-4">封鎖</v-btn>
                <v-btn v-else dark block outlined color="red darken-2" class="d-block mx-auto mt-4">已封鎖</v-btn>
              </span>
              <h2 class="my-6">{{ seller.nickname }}</h2>
              <div class="grey--text text--lighten-1">{{ seller.city }}</div>
              <span class="body-2 grey--text text--lighten-1">
                {{ seller.height }}cm 
                <span class="mx-2">|</span> 
                {{ `${seller.bust}${seller.cup} / ${seller.waist} / ${seller.hips}` }} 
                <span class="mx-2">|</span> 
                <span v-if="seller_job_types.length && seller.job">{{ seller_job_types.find(type => type.num == seller.job).name }}</span>
              </span>
              <div class="mt-6 mx-auto body-2 text-center">
                興趣: {{ seller.interest }}<br><br>
                {{ seller.self_intro }}
              </div>
            </div>
          </div>
        </v-col>
        <v-col class="right-info">
          <v-tabs v-model="tab" show-arrows dark background-color="transparent" color="pink" class="mb-6">
            <v-tab>長片</v-tab>
            <v-tab>動態</v-tab>
            <v-tab>寫真</v-tab>
            <v-tab>原味衣物</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" class="transparent">
            <v-tab-item :value="tab">
              <v-row no-gutters>
                <v-col 
                  style="padding: 6px"
                  :cols="['story', 'photo'].includes(item.product_type) ? 6 : $vuetify.breakpoint.width < 500 ? 12 : 6" 
                  :sm="['story', 'photo'].includes(item.product_type) ? 4 : 6" 
                  :md="['story', 'photo'].includes(item.product_type) ? 3 : 4" 
                  :lg="['story', 'photo'].includes(item.product_type) ? 2 : 3" 
                  :xl="['story', 'photo'].includes(item.product_type) ? 2 : 3"
                  v-for="(item, i) in items"
                  :key="i"
                >
                  <template v-if="['story', 'photo'].includes(item.product_type)">
                    <v-card 
                      dark 
                      class="story-item" 
                      flat 
                      @click="$root.$emit('story', seller, item, item.product_type)"
                    >
                      <span class="free" v-if="item.price === 0">Free</span>
                      <span class="unlocked" v-else-if="purchaseID.includes(item.id)">已解鎖</span>
                      <v-img
                        :src="$func.productImagePreview(item)"
                        gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.4)"
                        height="100%"
                        aspect-ratio="0.75"
                      >
                        <v-avatar size="35" :title="seller.nickname">
                          <v-img :src="$HOST_URL + seller.usericon"/>
                        </v-avatar>
                        <div class="description" :title="item.title">{{ item.title }}</div>
                      </v-img>
                    </v-card>
                  </template>
                  <template v-else>
                    <v-card 
                      class="product-item" 
                      :to="`/product/${item.id}`"
                      flat
                      dark
                      @mouseover="item.product_type == 'video' ? $func.startPlayVideo($refs, i, $HOST_URL + item.video_info[0].uuid_path) : ''"
                      @mouseleave="item.product_type == 'video' ? $func.stopPlayVideo($refs, i) : ''"
                    >
                      <span class="free" v-if="item.price === 0">Free</span>
                      <span class="unlocked" v-if="purchaseID.includes(item.id)">已解鎖</span>
                      <div class="soldOut" v-if="item.sold > 0 && item.product_type == 'clothes'">售罄</div>
                      <div :class="{sold: item.sold > 0 && item.product_type == 'clothes'}" style="width: 100%; height: 100%">
                        <template v-if="item.product_type == 'video'">
                          <video-player 
                            v-once
                            :ref="`video${i}`"
                            v-touch-event="() => $router.push(`/product/${item.id}`)"
                            :playsinline="true" 
                            @canplay="$func.onPlayerCanplay($event, i)"
                            :options="$func.videoOption({
                              src: $HOST_URL + item.video_info[0].uuid_path,
                              autoplay: false,
                              muted: true,
                              loop: true,
                              controls: false,
                              poster: $func.productImagePreview(item)
                            })"></video-player>
                        </template>
                        <template v-else>
                          <v-img :src="$func.productImagePreview(item)" aspect-ratio="1.75"/>
                        </template>
                        <div class="information">
                          <v-avatar size="35" class="mr-2" :title="seller.nickname">
                            <v-img :src="$HOST_URL + seller.usericon"/>
                          </v-avatar>
                          <v-col class="pa-0 rightInfo">
                            <div class="product-title text-ellipsis" :title="item.title">{{ item.title }}</div>
                            <div class="d-flex align-cente review">
                              <template v-if="!['clothes'].includes(item.product_type)">
                                <v-icon>fa-thumbs-up</v-icon>
                                <span>{{ mul(item.praise_rate, 100) }}%</span>
                              </template>
                              <template v-if="['video'].includes(item.product_type)">
                                <v-icon>fa-unlock</v-icon>
                                <span>{{ item.unlocks }}</span>
                              </template>
                              <template v-if="['clothes'].includes(item.product_type)">
                                <v-icon>fa-eye</v-icon>
                                <span>{{ item.views }}</span>
                              </template>
                            </div>
                          </v-col>
                        </div>
                      </div>
                    </v-card>
                  </template>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      busy: false,
      tab: 0,
      page: 1,
      seller: {},
      items: []
    }
  },
  created() {
    this.getSeller()
    // this.getData()
  },
  computed: {
    ...mapState('global', ['seller_job_types']),
    ...mapState('user', ['followList', 'blockList']),
    ...mapGetters('user', ['purchaseID']),
    isFollow() {
      return this.followList.map(seller => seller.id).includes(this.seller.id)
    },
    isBlock() {
      return this.blockList.map(seller => seller.id).includes(this.seller.id)
    },
    seller_id() {
      return this.$route.params.id
    }
  },
  watch: {
    tab() {
      this.page = 1
      this.items = []
      this.busy = false
      this.getData()
    }
  },
  methods: {
    getSeller() {
      this.axios(`/seller/${this.seller_id}`).then(response => {
        this.seller = response.data
        document.title = `${this.seller.nickname}的個人資料`
      })
    },
    async getData() {
      this.busy = true
      let last_page = null
      if(this.tab == 0) {
        last_page = await this.getVideos()
      }
      else if(this.tab == 1) {
        last_page = await this.getStorys()
      }
      else if(this.tab == 2) {
        last_page = await this.getPhotos()
      }
      else if(this.tab == 3) {
        last_page = await this.getClothes()
      }
      if(this.page != last_page) {
        this.page += 1  
        this.busy = false
      }
    },
    getVideos() {
      let origin = this.tab
      return this.axios(`/seller/${this.seller_id}/products?product_type=video&page=${this.page}&size=50`).then(response => {
        if(origin != this.tab) {
          return
        }
        this.items = this.items.concat(response.data.data.filter(item => item.shelf ? true : this.purchaseID.includes(item.id) ? true : false))
        return response.data.last_page
      })
    },
    getPhotos() {
      let origin = this.tab
      return this.axios(`/seller/${this.seller_id}/products?product_type=photo&page=${this.page}&size=50`).then(response => {
        if(origin != this.tab) {
          return
        }
        this.items = this.items.concat(response.data.data.filter(item => item.shelf ? true : this.purchaseID.includes(item.id) ? true : false))
        return response.data.last_page
      })
    },
    getStorys() {
      let origin = this.tab
      return this.axios(`/seller/${this.seller_id}/products?product_type=story&page=${this.page}&size=50`).then(response => {
        if(origin != this.tab) {
          return
        }
        this.items = this.items.concat(response.data.data.filter(item => item.shelf ? true : this.purchaseID.includes(item.id) ? true : false))
        return response.data.last_page
      })
    },
    getClothes() {
      let origin = this.tab
      return this.axios(`/seller/${this.seller_id}/products?product_type=clothes&page=${this.page}&size=50`).then(response => {
        if(origin != this.tab) {
          return
        }
        this.items = this.items.concat(response.data.data.filter(item => item.shelf ? true : this.purchaseID.includes(item.id) ? true : false))
        return response.data.last_page
      })
    },
    goChatroom() {
      this.axios(`/member/chat?seller_id=${this.seller_id}`).then(response => {
        const chatData = response.data.data && response.data.data[0] ? response.data.data[0] : {}
        const room = Object.assign({seller: this.seller}, chatData)
        console.log({seller: this.seller}, room)
        this.$router.push({name: 'Chatroom', params: {room: room}})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.seller {
  .icon {
    border: 3px solid white;
  }
  .container {
    @media (max-width: 1600px) {
      max-width: 1600px;
    }
    @media (max-width: 1264px) {
      max-width: 1185px;
    }
    @media (max-width: 960px) {
      max-width: 100%;
    }
    .left-info {
      margin-top: -110px;
      flex: 0 0 100%;
      max-width: 100%;
      flex: 0 0 25%;
      max-width: 25%;
      & > div {
        max-width: 280px;
        margin: auto;
      }
      @include tablet {
        flex: 0 0 100%;
        max-width: 100%;
      }
      @include mobile {
        flex: 0 0 100%;
        max-width: 100%;
      }
      .other-info {
        display: flex;
        flex-direction: column;
        margin: 0 20px;
        font-size: 14px;
        align-items: center;
        line-height: 24px;
        @include mobile {
          margin: 0 10px;
        }
        div {
          white-space: nowrap;
        }
      }
    }
    .right-info {
      padding: 8px 16px;
      flex: 0 0 75%;
      max-width: 75%;
      min-height: 350px;
      @include tablet {
        flex: 0 0 100%;
        max-width: 100%;
        padding: 8px 0;
      }
      @include mobile {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
  }
}
</style>